import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import { ConsultarStore } from '../ConsultarStore'
import { AgendamentoModel, TipoAgendamento, TurmaModel } from '../../../../components/models/Models'
import { Table, TableColumnsType } from 'antd'
import { formatDate } from '../../../../components/common/Utils'
import { Center } from '../../../../components/common/Center'
import { ReactComponent as CheckMark } from '../../../../assets/icons/check-mark.svg'
import { ReactComponent as HourGlass } from '../../../../assets/icons/hour-glass.svg'
import { ReactComponent as Warning } from '../../../../assets/icons/warning.svg'
import { BooleanIcon } from '../../../../components/common/BooleanIcon'
import { StatusDetranIcon } from '../../../../components/agendamentos/StatusDetranIcon'

export const Turmas = () => {
  const { getColumns, turmaToTableRecord } = Turmas
  const { turmas } = ConsultarStore.useState()

  const data = useMemo(() => {
    return turmas?.map((t: TurmaModel, i: number) => turmaToTableRecord(i, t))
  }, [turmas])

  const handleExpadendRowRender = (t: TurmaModel | any) => <Alunos turma={t} />

  return (
    <Table
      showHeader={false}
      pagination={false}
      columns={getColumns()}
      dataSource={data}
      expandable={{
        expandRowByClick: true,
        expandedRowRender: handleExpadendRowRender,
      }}
    />
  )
}
Turmas.Pendencia = ({ agendamentos }: { agendamentos: AgendamentoModel[] }) => {
  const isAllTrue = (callback: (agendamento: AgendamentoModel) => any) =>
    agendamentos.map((a) => callback(a)).reduce((prev, curr) => prev && curr, true)

  const isAgendadosDetran = isAllTrue((a) => a.statusDetran === 'CONFIRMADO')
  const isImportadosDetran = isAllTrue((a) => !!a.dataImportacaoSuperPratico)

  if (isAgendadosDetran && isImportadosDetran) return <CheckMark width="18px" fill="green" />
  if (isAgendadosDetran || isImportadosDetran) return <HourGlass width="18px" fill="#f8d302" />
  return <Warning width="18px" fill="red" />
}
Turmas.getColumns = () => {
  return [
    {
      key: 'modalidade',
      dataIndex: 'modalidade',
      align: 'left',
      fixed: true,
    },
    {
      key: 'tipoCurso',
      dataIndex: 'tipoCurso',
      align: 'left',
      fixed: true,
    },
    {
      key: 'dataInicio',
      dataIndex: 'dataInicio',
      align: 'left',
      fixed: true,
    },
    {
      key: 'qtdAlunos',
      dataIndex: 'qtdAlunos',
      align: 'center',
      fixed: true,
    },
    {
      key: 'qtdAlunosReposicao',
      dataIndex: 'qtdAlunosReposicao',
      align: 'center',
      fixed: true,
    },
    {
      key: 'pendencia',
      dataIndex: 'pendencia',
      align: 'center',
      fixed: true,
    },
  ] as TableColumnsType<object>
}
Turmas.turmaToTableRecord = (key: any, turma: TurmaModel) => {
  const { Pendencia } = Turmas
  const agendamentos = turma?.agendamentos

  const getQtdAgendamentosByTipo = (tipo: TipoAgendamento) =>
    agendamentos.filter((v) => v.tipoAgendamento === tipo).length

  const qtdAlunos = getQtdAgendamentosByTipo('REGULAR')
  const qtdAlunosReposicao = getQtdAgendamentosByTipo('REPOSICAO')

  return {
    key: key,
    modalidade: <MasterTitle label="Modalidade">{turma.modalidade}</MasterTitle>,
    tipoCurso: <MasterTitle label="Tipo Curso">{turma.tipoCurso}</MasterTitle>,
    dataInicio: <MasterTitle label="Data de início">{formatDate(turma.dataInicio)}</MasterTitle>,
    qtdAlunos: <MasterTitle label="Alunos de primeiro curso">{qtdAlunos}</MasterTitle>,
    qtdAlunosReposicao: <MasterTitle label="Alunos de reposição">{qtdAlunosReposicao}</MasterTitle>,
    pendencia: <Pendencia agendamentos={agendamentos} />,
    observacao: turma.observacao,
    agendamentos: agendamentos,
  }
}

const MasterTitle = ({ label, children }: { label: string; children: any }) => {
  return (
    <label>
      <div style={{ fontSize: '15pt' }}>{children}</div>
      <div style={{ fontSize: '9pt' }}>{label}</div>
    </label>
  )
}

const Alunos = ({ turma }: { turma: TurmaModel }) => {
  const { Observacao, Lista, Titles } = Alunos

  return (
    <div>
      <Observacao>
        <em>{turma?.observacao}</em>
      </Observacao>

      <Titles>
        <span>CPF</span>
        <span>Nome</span>
        <span>CFC Destino</span>
        <Center>
          <span>Agendado no Detran</span>
        </Center>
        <Center>
          <span>Importado no Super Prático</span>
        </Center>
        <Center>
          <span>Motivo do cancelamento ou pendência no Detran</span>
        </Center>
      </Titles>

      <Lista>
        {turma?.agendamentos.map((value: any, index: any) => (
          <Aluno key={index} agendamento={value} />
        ))}
      </Lista>
    </div>
  )
}
Alunos.Lista = styled.div`
  border-radius: 10px;
  overflow: hidden;
  border-bottom: 1px solid #b3b3b39d;

  div:last-child {
    border-bottom: none;
  }
`
Alunos.Observacao = styled.div`
  background-color: #e6eef5;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
`
Alunos.Titles = styled.div`
  border-bottom: 1px solid #b3b3b39d;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  column-gap: 10px;
  background-color: #ccd0d46f;
  padding: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`

const Aluno = ({ agendamento }: { agendamento: Partial<AgendamentoModel> }) => {
  const { Layout } = Aluno
  return (
    <Layout>
      <p>{agendamento.cpf}</p>
      <p>{agendamento.nome}</p>
      <p>{agendamento.cfcDestino?.fantasia}</p>
      <Center>
        <StatusDetranIcon status={agendamento?.statusDetran} />
      </Center>
      <Center>
        <BooleanIcon condition={!!agendamento.dataImportacaoSuperPratico} />
      </Center>
      <Center>
        <strong style={{ color: '#f14545' }}>
          <em>{agendamento.motivo}</em>
        </strong>
      </Center>
    </Layout>
  )
}
Aluno.Layout = styled.div`
  border-bottom: #d6d9da 1px solid;
  /* border-radius: 10px; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  column-gap: 10px;
  background-color: #eef0ed86;
  padding: 7px;
`
